import { Logger, LoggerService } from "@Shared/logger";
import { PipelineContext, PipelineStep } from "@Modules/pipeline_module/_base";
import { Bus, OnEntitlementDeterminedResult } from "@Modules/event_module";
import { APP_EVENTS } from "@Core";
import { buildEntitlementExtra, EntitlementService, EntitlementUtils } from "@Modules/entitlement_module";
import { AsyncUtils } from "@Shared/utils";
import { ScreenManager } from "@Modules/ui_module";
import { buildPostCallbackStep } from "../auth/check-auth-status.step";
import {MaybeUpdateSessionServerStep} from "@Modules/pipeline_module/steps/session/update-session.step";
import { OptionsModule } from "@Modules/options_module";
import { SessionService } from "@Modules/session_module";

export class CheckEntitlementStep implements PipelineStep {
    private entitlementService: EntitlementService;
    private Logger: Logger = LoggerService.createLogger("CheckEntitlementStep");

    

    constructor() {
        this.Logger.trace("****  CTOR ****");
        
    }
    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace("Executing....", context);
        this.entitlementService = EntitlementService.Instance;

        
        const screenManager = ScreenManager.Instance;
        this.Logger.trace("CheckEntitlementStep.from OnLogin", context.onLogin);
        if (context.showEntitlementCheckScreen) {
            screenManager.CurrentScreen?.Alert?.hide();
            screenManager.showScreen('entitlementCheck');
            await AsyncUtils.delay(1000);

        }
        Bus.emit(APP_EVENTS.onEntitlementStarted);
        const s = await this.entitlementService.checkEntitlements();
        this.Logger.info("checkEntitlements RESULT", s);
        let entitledDeterminedEvent: OnEntitlementDeterminedResult = undefined
        if(s.status === 'valid') {
            this.entitlementService.setLocalSession(s.entitlement.session);
            const extra = buildEntitlementExtra(s.entitlement.decoded);
            this.Logger.info("Entitlement check result", s.entitlement.session);
            await SessionService.Instance.maybeUpdateWholeSession(s.entitlement.session);
            entitledDeterminedEvent = { mngSession: s.entitlement.session, entitlement: extra, successSource: s.source.kind };
        }
        
        
        context.checkEntitlements = entitledDeterminedEvent;
        this.Logger.trace("Entitlement check result.entitledDeterminedEvent", entitledDeterminedEvent);
        screenManager.closeScreen();
        Bus.emit(APP_EVENTS.onEntitlementsDetermined, entitledDeterminedEvent);
        
        // fire 'entitlementsReady' event to play nice with legacy CMS functionality
        EntitlementUtils.fireLegacyEntitlementsReadyEvent(entitledDeterminedEvent?.mngSession?.entitlementToken || false);

        // Only push to the session server when we actually have a valid entitlement session.
        // On server-failed refresh/create, checkEntitlements is undefined — updating would throw
        // and abort the pipeline before onReady (leaving the CMS login button stuck on spinner).
        context.sessionServerNeedsUpdate = s.status === 'valid' && s.source.kind === 'server';
        if (OptionsModule.Options.session.enabled && context.sessionServerNeedsUpdate) {
            return new MaybeUpdateSessionServerStep();
        }
        return buildPostCallbackStep();

        
    }
}